import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";


@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

  constructor(private translate: TranslateService) { }

  load(): Promise<any> {
    this.translate.addLangs(['en', 'it']);

    const browserLang = this.translate.getBrowserLang();
    const defaultLang = (!localStorage.getItem('localLanguage')) ? (browserLang?.match(/en|it/) ? browserLang : 'it') : localStorage.getItem('localLanguage');
    this.translate.setDefaultLang(defaultLang!);
    this.translate.use(defaultLang!);
    this.translate.onLangChange.subscribe(
      (lE) => localStorage.setItem('localLanguage', lE.lang)
    );
    let promiseResolve: any = null;
    const promiseMe = new Promise((resolve) => {
      promiseResolve = resolve;
    });

    promiseResolve(true);

    return promiseMe;
  }

}
